import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Mixpanel from "@/services/tracking";

export default function useScreenTracking(properties = {}) {
  const location = useLocation();

  useEffect(() => {
    Mixpanel.track("Screen", { page: location, ...properties });
  }, [location, properties]);
}
